import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { CreateQuestion } from "./entities/create-question";
import { QuestionOption } from "./entities/question-option";
import { AuthenticationEntity } from "../authentications/entities/authentications.entity";
import { QuestionBankController } from "./create-question-controller";
import { QuestionBankService } from "./create-question.service";
import { CreateQuestionAdapter } from "./dtos/create-question.adapter";
import { CreateQuestionRepo } from "./repos/create-question-repo";
import { CollegeCodesAndSymobols } from "./entities/college-codes-symbols.entity";
import { CollegeCodesAndSymbolsRepo } from "./repos/college-codes-symbols.repo";

import { ClassRepo } from "../ai-generated-qp/repo/class-repo";
import { SubjectRepo } from "../ai-generated-qp/repo/subject-repo";
import { ChapterRepo } from "../ai-generated-qp/repo/chapter-repo";
import { TopicRepo } from "../ai-generated-qp/repo/topic-repo";
import { LanguagesRepo } from "../ai-generated-qp/repo/languages-repo";
import { AbilityRepo } from "../ai-generated-qp/repo/ability-repo";
import { AbilityTypeRepo } from "../ai-generated-qp/repo/ability-type-repo";
import { ComplexityRepo } from "../ai-generated-qp/repo/complexity-repo";
import { QuestionTypeMasterRepo } from "../ai-generated-qp/repo/question-type-master-repo";
import { CompetencyCodeRepo } from "../ai-generated-qp/repo/competency-code-repo";
import { Ability } from "../entities/abilities";
import { AbilityType } from "../entities/ability-types";
import { Complexity } from "../entities/complexity";
import { QuestionTypeMaster } from "../entities/question-type-master";
import { CompetencyCode } from "../entities/competency-code";
import { Topic } from "../entities/topic";
import { Subject } from "../entities/subject";
import { Chapter } from "../entities/chapter";
import { LanguageEntity } from "../entities/language";
import { ClassEntity } from "../entities/class";
import { Department } from "../entities/department-entity";
import { DepartmentRepo } from "../ai-generated-qp/repo/department-repo";

@Module({
    imports: [TypeOrmModule.forFeature([CreateQuestion, QuestionOption, CollegeCodesAndSymobols, Ability, AbilityType, Complexity, QuestionTypeMaster, CompetencyCode, Topic, Subject, Chapter, LanguageEntity, ClassEntity, AuthenticationEntity, Department])],
    controllers: [QuestionBankController],
    providers: [QuestionBankService, CreateQuestionAdapter, CreateQuestionRepo, CollegeCodesAndSymbolsRepo, ClassRepo, SubjectRepo, ChapterRepo, TopicRepo, LanguagesRepo, AbilityRepo, AbilityTypeRepo, ComplexityRepo, QuestionTypeMasterRepo, CompetencyCodeRepo, DepartmentRepo],
    exports: [QuestionBankService]
})

export class QuestionBankCreationModule { }